import React, { FC } from 'react'


interface RightArrowIconProps {
    className?: string;
}
const RightSideArrow :FC<RightArrowIconProps> = ({className}) => {
  return (
    <svg  xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" className={className}>
  <path d="M14.3538 8.35403L9.85375 12.854C9.75993 12.9478 9.63268 13.0006 9.5 13.0006C9.36732 13.0006 9.24007 12.9478 9.14625 12.854C9.05243 12.7602 8.99972 12.633 8.99972 12.5003C8.99972 12.3676 9.05243 12.2403 9.14625 12.1465L12.7931 8.50028H3C2.86739 8.50028 2.74021 8.4476 2.64645 8.35383C2.55268 8.26006 2.5 8.13289 2.5 8.00028C2.5 7.86767 2.55268 7.74049 2.64645 7.64672C2.74021 7.55296 2.86739 7.50028 3 7.50028H12.7931L9.14625 3.85403C9.05243 3.76021 8.99972 3.63296 8.99972 3.50028C8.99972 3.3676 9.05243 3.24035 9.14625 3.14653C9.24007 3.05271 9.36732 3 9.5 3C9.63268 3 9.75993 3.05271 9.85375 3.14653L14.3538 7.64653C14.4002 7.69296 14.4371 7.74811 14.4623 7.80881C14.4874 7.86951 14.5004 7.93457 14.5004 8.00028C14.5004 8.06599 14.4874 8.13105 14.4623 8.19175C14.4371 8.25245 14.4002 8.30759 14.3538 8.35403Z" fill="currentColor"/>
</svg>
  )
}

export default RightSideArrow